/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/queries/feedbackQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { useSendAiFeedbackMutation } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/AiFeedbackRpc.hooks';
import { handleApolloErrors } from '../../../utils/errorUtils.legacy';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/queries/feedbackQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useSendAiFeedback = options => {
  const [sendAiFeedback, {
    loading,
    error,
    data
  }] = useSendAiFeedbackMutation(Object.assign({
    onError: err => handleApolloErrors({
      error: err,
      loggingTitle: 'learningCenter.interactiveEducation.errors.feedbackError'
    })
  }, options));
  return {
    sendAiFeedback,
    loading,
    error,
    data
  };
};